import { render } from "./ProvisionPhoneNumbers.vue?vue&type=template&id=4bbd4fa2"
import script from "./ProvisionPhoneNumbers.vue?vue&type=script&lang=js"
export * from "./ProvisionPhoneNumbers.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__